import PhoneDisabledIcon from "@mui/icons-material/PhoneDisabled";
import { Box, Chip, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

// Styled components matching Five9CompactStatus design
const StatusContainer = styled(Box)(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	gap: theme.spacing(1),
	padding: theme.spacing(0.5, 1),
	borderRadius: theme.spacing(1),
	backgroundColor: theme.palette.grey[100],
	border: `1px solid ${theme.palette.grey[300]}`,
	minHeight: "36px",
	cursor: "default",
	opacity: 0.7,
	"&:hover": {
		backgroundColor: theme.palette.grey[200],
	},
}));

const StatusText = styled(Typography)(({ theme }) => ({
	fontSize: "0.875rem",
	fontWeight: 500,
	color: theme.palette.text.secondary,
	whiteSpace: "nowrap",
}));

const DurationChip = styled(Chip)(({ theme }) => ({
	height: "20px",
	fontSize: "0.75rem",
	fontWeight: 500,
	backgroundColor: theme.palette.grey[200],
	color: theme.palette.text.secondary,
	"& .MuiChip-label": {
		paddingX: theme.spacing(0.75),
	},
}));

/**
 * Development placeholder for Five9State component
 * Shows when Five9 integration is disabled in non-production environments
 */
const Five9DevPlaceholder: React.FC = () => {
	return (
		<StatusContainer>
			<PhoneDisabledIcon sx={{ fontSize: 16, color: "text.secondary" }} />
			<StatusText>Five9 Not Available</StatusText>
			<DurationChip label="DEV" size="small" variant="outlined" />
		</StatusContainer>
	);
};

export default React.memo(Five9DevPlaceholder);
